module.exports = __webpack_public_path__ + "static/media/devicehires.f82f8afe.png";